<template>
  <div>
    <div class="pc-billinginfo-skeleton gc-page__container">

      <div class="pc-billinginfo-skeleton__cards"> 
        <AnimatedPlaceholder width="100%" height="188px" border-radius="10px" v-for="index in 3"
        :key="index"/>
        
      </div>
  </div>
  </div>
</template>

<script >
import AnimatedPlaceholder from "@/components/global/animators/AnimatedPlaceholder";


export default {
  name: "pc-profile-skeleton",
  components: { AnimatedPlaceholder },
};
</script>

<style>

</style>